import { useEffect, useRef } from "react";

const dores = [
  {
    icon: "ri-question-line",
    title: "Falta de clareza",
    desc: "Gestores sem visibilidade sobre o que estão contratando, o que cobre e o que realmente vale para os colaboradores.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Custos elevados",
    desc: "Contratos mal negociados e reajustes abusivos que consomem o orçamento sem entregar valor proporcional.",
  },
  {
    icon: "ri-file-unknow-line",
    title: "Dificuldade na escolha",
    desc: "Excesso de opções no mercado sem critério técnico para comparar e selecionar o que realmente faz sentido.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Falta de suporte consultivo",
    desc: "Corretores que vendem e somem, sem acompanhamento estratégico após a contratação.",
  },
  {
    icon: "ri-emotion-sad-line",
    title: "Baixa percepção de valor",
    desc: "Colaboradores que não entendem ou não valorizam os benefícios oferecidos pela empresa.",
  },
  {
    icon: "ri-time-line",
    title: "Gestão operacional pesada",
    desc: "RH sobrecarregado com processos manuais, reembolsos e demandas que poderiam ser automatizadas.",
  },
];

export default function Dores() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".dor-card").forEach((card, i) => {
              setTimeout(() => card.classList.add("dor-visible"), i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="dores" className="py-16 lg:py-20 bg-[#0D0D0D]" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-6 h-px bg-[#FBC52D]" />
            <span className="text-[#FBC52D] text-xs font-semibold tracking-widest uppercase">
              Reconhece algum desses cenários?
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
            Os desafios que travam a gestão de benefícios
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            Empresas de todos os tamanhos enfrentam os mesmos obstáculos. A diferença está em como você os resolve.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {dores.map((dor) => (
            <div
              key={dor.title}
              className="dor-card opacity-0 translate-y-6 transition-all duration-500 group bg-white/5 border border-white/8 rounded-2xl p-7 hover:bg-white/8 hover:border-[#FBC52D]/30 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#FBC52D]/10 mb-5 group-hover:bg-[#FBC52D]/20 transition-colors">
                <i className={`${dor.icon} text-[#FBC52D] text-xl`} />
              </div>
              <h3 className="text-white font-semibold text-base mb-2">{dor.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{dor.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .dor-visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}